export class RegistrationEvent {
    registrationEventID: number;
    contactID: number;
}

